export const routes = {
  root: '/',
  fixedTerm: '/fixed-term',
  fixedTermMarket: '/fixed-term/:network/:vaultId',
  borrow: '/borrow',
  borrowMarket: '/borrow/market/:network/:marketId/:assetId',
  discover: '/discover',
  opportunity: '/opportunity/:network/:vaultId',
  dashboard: '/dashboard/:address',
  swap: '/swap',
  cctp: '/cctp',
  analytics: '/analytics',
  track: '/track/:address',
  terms: '/terms-of-service',
  disclaimer: '/disclaimer',
  privacy: '/privacy-policy',
} as const

export const apiRoutes = {
  apiProxy: '/api/proxy',
  apiHealth: '/api/health',
  apiBestPerformingVaults: '/api/best-performing-vaults',
  apiHistoricalBenchmarks: '/api/historical-benchmarks',
  apiRpc: '/api/rpc',
}
